/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from 'react';
import { LftSidePaneExperiment } from '../../experiments/LftCountdown/LftSidePane';

export const LftSidePaneView = () => {
    return <LftSidePaneExperiment />;
};

export default LftSidePaneView;
